import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountCashback.js';
import Loader from 'Loader.js';
import Datepicker from 'Datepicker.js';
import Pagination from 'Pagination.js';
import classNames from 'classnames';
import { translation, formatMoney } from 'helpers/utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import {
  changeDateByType,
  changeActiveTab,
  fetchCashbackByFilter,
  setCurrentPage,
} from 'accountCashbackActions.js';
import ReactTooltip from 'react-tooltip';
import { proccessFrontError } from 'errorActions.js';

class AccountCashback extends Component {
  componentDidMount = async () => {
    const { fetchCashbackByFilter, processFrontError } = this.props;
    try {
      await fetchCashbackByFilter();
    } catch (error) {
      processFrontError(error, 'AccountCashback.componentDidMount');
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchCashbackByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchCashbackByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchCashbackByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchCashbackByFilter();
    });
  };

  goPage = (currentPage) => {
    const { fetchCashbackByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCashbackByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountCashback.goPage');
    }
  };

  render() {
    const { isPending, startDate, endDate, currencyCode, activeTab, cashback, limit } =
      this.props;
    const activeCashback = cashback[activeTab];
    const { data, isNextPageAvailable, currentPage } = activeCashback;

    return (
      <S.AccountCashback>
        <S.CashbackFilters className="wallet-filters">
          <S.CashbackFiltersDates className="wallet-filters-dates">
            <S.DateWrapper className="date-wrapper">
              <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
              <Datepicker
                selected={startDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                cb={this.handleChangeStart}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.DateWrapper>

            <S.DateWrapper className="date-wrapper">
              <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
              <Datepicker
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                cb={this.handleChangeEnd}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.DateWrapper>
          </S.CashbackFiltersDates>

          <S.CashbackFiltersBtns className="cashback-btns-wrapper">
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, 'paid')}
              className={classNames({ active: status == 'paid' })}
            >
              {translation('account_cashback_paid')}
            </S.FilterBtn>
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, 'awaiting')}
              className={classNames({ active: status == 'awaiting' })}
            >
              {translation('account_cashback_awaiting')}
            </S.FilterBtn>
          </S.CashbackFiltersBtns>
        </S.CashbackFilters>

        <S.CashbackList className="cashback-list">
          {isPending ? (
            <Loader />
          ) : (
            <>
              <S.Table className="cashback-table">
                <S.Head>
                  <S.Row className="row">
                    <S.Th>{translation('account_cashback_betSlipId')}</S.Th>
                    <S.Th>{translation('account_cashback_createTime')}</S.Th>
                    <S.Th>{translation('account_cashback_offerName')}</S.Th>
                    <S.Th>{translation('account_cashback_paidValue')}</S.Th>
                    <S.Th>
                      <i className="ion ion-help-circled"></i>
                    </S.Th>
                  </S.Row>
                </S.Head>

                <S.Body>
                  {data.map(
                    ({
                      betSlipId,
                      createTime,
                      offerId,
                      descriptionKey,
                      paidValue = 0,
                      nameKey,
                    }) => {
                      return (
                        <S.Row className="row" key={offerId}>
                          <S.Td>{betSlipId}</S.Td>
                          <S.Td>{formatDate(createTime, 'yyyy-MM-dd HH:mm')}</S.Td>
                          <S.Td>{translation(nameKey)}</S.Td>
                          <S.Td>
                            {formatMoney(paidValue)} {currencyCode}
                          </S.Td>
                          <S.Td>
                            <a data-tip data-for="cashback_desc">
                              ?
                            </a>
                            <ReactTooltip id="cashback_desc" type="light">
                              <span
                                dangerouslySetInnerHTML={{ __html: translation(descriptionKey) }}
                              ></span>
                            </ReactTooltip>
                          </S.Td>
                        </S.Row>
                      );
                    }
                  )}

                  {!data.length ? (
                    <S.Row className="no-result">
                      <S.Td colSpan="5">{translation('account_cashback_notFound')}</S.Td>
                    </S.Row>
                  ) : null}
                </S.Body>
              </S.Table>

              {data.length > 0 ? (
                <Pagination
                  {...{
                    currentPage,
                    limit,
                    data,
                    isNextPageAvailable,
                    callback: this.goPage,
                  }}
                />
              ) : null}
            </>
          )}
        </S.CashbackList>
      </S.AccountCashback>
    );
  }
}

const mapStateToProps = ({
  AccountCashback: { isPending, error, startDate, endDate, activeTab, cashback, limit },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    cashback,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchCashbackByFilter: bindActionCreators(fetchCashbackByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountCashback);
